<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8327 6.8763V6.8763C12.8327 5.74833 12.8327 5.18435 12.6117 4.75416C12.4208 4.38244 12.1182 4.07987 11.7465 3.88894C11.3163 3.66797 10.7523 3.66797 9.62435 3.66797H7.66602C5.7804 3.66797 4.83759 3.66797 4.2518 4.25376C3.66602 4.83954 3.66602 5.78235 3.66602 7.66797V9.6263C3.66602 10.7543 3.66602 11.3183 3.88698 11.7484C4.07792 12.1202 4.38049 12.4227 4.75221 12.6137C5.1824 12.8346 5.74638 12.8346 6.87435 12.8346V12.8346"
      stroke="url(#paint0_linear_2356_21655)"
      stroke-width="1.5"
    />
    <rect
      x="9.16602"
      y="9.16797"
      width="9.16667"
      height="9.16667"
      rx="2"
      stroke="url(#paint1_linear_2356_21655)"
      stroke-width="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2356_21655"
        x1="8.24935"
        y1="3.66797"
        x2="8.24935"
        y2="12.8346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2356_21655"
        x1="13.7493"
        y1="9.16797"
        x2="13.7493"
        y2="18.3346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.btn-icon {
  svg {
    width: 1.571rem;
    height: 1.571rem;
  }
}
</style>
